// import { Suspense } from 'react';
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
// import { HelmetProvider } from 'react-helmet-async';
// //
// import App from './App';

// // ----------------------------------------------------------------------

// const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// root.render(
//   <HelmetProvider>
//     <BrowserRouter>
//       <Suspense>
//         <App />
//       </Suspense>
//     </BrowserRouter>
//   </HelmetProvider>
// );


import 'src/utils/install-secure-local-storage';

import 'src/iconify/register-offline-iconify';

import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
//
import App from './App';

 
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);

// 🔥 Unregister service worker to disable cache
serviceWorkerRegistration.unregister();
